<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.text_269')}}</div>
    <div slot="body">
      <a-alert class="mb-2" type="warning" :message="$t('bill.ignore_tips')" />
      <dialog-selected-tips :name="$t('bill.suggest')" :count="params.data.length" :action="$t('bill.text_269')" :unit="$t('bill.suggest_unit')" />
      <dialog-table class="mb-2" :data="params.data" :columns="params.columns" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'IgnoreDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    doAction () {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'ignore',
          data: {
            scope: this.$store.getters.scope,
          },
        },
      }).then(ret => {
        this.$message.success(this.$t('bill.text_59'))
      })
    },
    doBatchAction () {
      const ids = this.params.data.map(v => v.id)
      return this.params.onManager('batchPerformAction', {
        ids,
        managerArgs: {
          action: 'ignore',
          data: {
            scope: this.$store.getters.scope,
          },
        },
      }).then(ret => {
        this.$message.success(this.$t('bill.text_59'))
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        if (this.params.data.length > 1) {
          await this.doBatchAction()
        } else {
          await this.doAction()
        }
        this.loading = false
        this.cancelDialog()
        this.params.success && this.params.success()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
